import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = ['Honest estimates and transparent communication', 'Experienced team specializing in mobile home repair and maintenance', 'High-quality workmanship backed by integrity and accountability', 'Community-focused service that goes beyond the job site', 'Senior discounts available', 'Open 7 days a week for your convenience', 'Free estimates on all projects', 'Pride in our work and commitment to excellence'];
  return <div className="w-full bg-gradient-to-br from-red-700 via-red-600 to-red-700 py-20 px-4" data-id="element-93">
      <div className="max-w-7xl mx-auto" data-id="element-94">
        <div className="text-center mb-16" data-id="element-95">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-96">
            Why Homeowners Choose The Mobile Home Dr
          </h2>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto" data-id="element-97">
            From leveling and structural repair to interior upgrades and
            exterior restoration, we're your trusted partner for dependable,
            long-lasting mobile home solutions.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-98">
          {reasons.map((reason, index) => <div key={index} className="flex items-start gap-4 bg-red-800 p-6 rounded-lg" data-id="element-99">
              <CheckCircleIcon className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-100" />
              <p className="text-lg text-white" data-id="element-101">{reason}</p>
            </div>)}
        </div>
      </div>
    </div>;
}